// extracted by mini-css-extract-plugin
export var addToCartButton = "_ox-b";
export var arrowButtonContainer = "_ox-9";
export var arrowButtonIcon = "_ox-a";
export var carouselArrowButton = "_ox-6";
export var carouselElementContainer = "_ox-1";
export var left = "_ox-7";
export var productDisplayCarouselContainer = "_ox-0";
export var productTileContainer = "_ox-2";
export var productTileImage = "_ox-4";
export var productTileImageContainer = "_ox-3";
export var productTileTitle = "_ox-5";
export var right = "_ox-8";
export var sliderOverflow = "_ox-c";